import Box from '@mui/material/Box';
import { LoadingSpinner } from '@opengov/component-library/capital/LoadingSpinner';
import React from 'react';
import { styles } from './StoryLoadingSpinner.styles';

export function StoryLoadingSpinner() {
  return (
    <Box sx={styles.container}>
      <LoadingSpinner variant="page" />
    </Box>
  );
}
